import { useState } from 'react';
import PostingsApi from '../../../API/shipment/postings-api';
import { TYPE_BUTTONS } from '../../../constans';
import { PopUp, Row } from '../../Basic/Blocks';
import { Button } from '../../Basic/Buttons';
import { Input, Select } from '../../Basic/Inputs';
import { H2, Text } from '../../Basic/WrapsStyle';
import styles from './styles.module.scss';

const MAP_CATEGORY = {
  'Запросы на камеру': 'Камера',
  'Проверка отгрузок': 'Отгрузка',
  'Проверка расхождений': 'Расхождения',
};

const AddToCheckupsPopUp = ({ close = () => { }, postings = [] }) => {
  let [typeReview, setSelectTypeReview] = useState('');
  let [reason_type, setSelectTypeReason] = useState('');
  let [reason_comment, setReasonComment] = useState('');

  const clickOk = async () => {
    await PostingsApi.changePostings({
      data: {
        postingNumbers: postings,
        field: 'checkups',
        value: {
          checkup_category: MAP_CATEGORY[typeReview],
          reason_type,
          reason_comment,
        },
      }
    });
    close();
  };

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>Перенести в проверку</H2>

      <Select
        list={['Запросы на камеру', 'Проверка отгрузок']}
        select={typeReview}
        label={'Раздел проверки'}
        onSelect={(v) => setSelectTypeReview(v)}
      />
      <Select
        list={[
          'Другое',
          'Неотгруз',
          'Много отмен',
          'Косяк склада',
          'Экспрессы',
          'Неотгруз докупа',
          'Проверка излишек',
          'Отгрузка не вовремя',
          'Упаковка не вовремя',
        ]}
        select={reason_type}
        label={'Причина проверки'}
        onSelect={(v) => setSelectTypeReason(v)}
        style={{ marginTop: '15px' }}
      />
      <Input
        label="Комментарий"
        value={reason_comment}
        onBlur={(v) => setReasonComment(v)}
        style={{ marginTop: '10px' }}
      />

      <Text fontSize={15} style={{ marginTop: '10px' }}>{`Количество заказов ${postings.length}`}</Text>
      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{
            marginRight: '15px',
          }}
          onClick={clickOk}
        >
          Перенести
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default AddToCheckupsPopUp;
